var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dapp-page"},[_c('v-row',{staticClass:"h-100",attrs:{"no-gutters":"","align":"center"}},[_c('v-col',{staticClass:"pa-4 text-center",attrs:{"cols":"12"}},[_vm._v(" coming soon ... ")])],1),_c('bottom-nav')],1)}
var staticRenderFns = []

export { render, staticRenderFns }